import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { wechatLoginLog } from '../utils/wechatLoginLog';

type Props = {
  /** 公众号 oauth2/authorize 完整 URL */
  authUrl: string | null;
  /** 正在请求后端获取 authUrl */
  loading: boolean;
  fetchError: string | null;
};

/**
 * 将公众号网页授权链接渲染为二维码（PC 浏览器用微信扫码打开）
 */
const WeChatOAuthQrDisplay: React.FC<Props> = ({ authUrl, loading, fetchError }) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [genErr, setGenErr] = useState<string | null>(null);

  useEffect(() => {
    setDataUrl(null);
    setGenErr(null);
    if (!authUrl) return;
    wechatLoginLog('qr_image_generate_start', { authUrlLen: authUrl.length });
    let cancelled = false;
    QRCode.toDataURL(authUrl, { width: 224, margin: 2, errorCorrectionLevel: 'M' })
      .then((d) => {
        if (!cancelled) {
          setDataUrl(d);
          wechatLoginLog('qr_image_generate_ok', { dataUrlLen: d.length });
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setGenErr('二维码生成失败');
          wechatLoginLog('qr_image_generate_fail', { err: e instanceof Error ? e.message : String(e) });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [authUrl]);

  if (loading) {
    return <p className="wechat-done-msg">加载中…</p>;
  }
  if (fetchError) {
    return <p className="wechat-done-msg wechat-done-err">{fetchError}</p>;
  }
  if (genErr) {
    return <p className="wechat-done-msg wechat-done-err">{genErr}</p>;
  }
  if (!authUrl) {
    return null;
  }
  if (!dataUrl) {
    return <p className="wechat-done-msg">正在生成二维码…</p>;
  }
  return (
    <>
      <p className="wechat-qr-modal-tip">请使用微信扫描下方二维码，在手机微信中完成登录</p>
      <img className="wechat-mp-oauth-qr" src={dataUrl} alt="" width={224} height={224} />
    </>
  );
};

export default WeChatOAuthQrDisplay;
